import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ScholarshipPaymentDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ScholarshipPaymentId: string;
	@IsNotEmpty() StudentName: string;
	@IsNotEmpty() ScholarshipAwardNo: string;
                AccountNo: string;
                AccountName: string;
	@IsNotEmpty() BankName: string;
	              Branch: string;
	@IsNotEmpty() AmountPaid: number;
	@IsNotEmpty() Outstanding: number;
	@IsNotEmpty() PaymentDescription: string;
	@IsNotEmpty() SubscriberId: string;

	@IsNotEmpty() DatePaid: Date;
	@IsNotEmpty() PostedBy: string;
	@IsNotEmpty() PaymentMode: string;
                BankId: string;
                CurrencyId: string;
	@IsNotEmpty() StudentId: string;
}
